<template>
  <div class="tw-flex tw-h-screen tw-bg-gray-200 tw-w-full tw-p-6 tw-items-center tw-justify-center">
    <div v-if="isLoading">
      <base-card class="tw-w-96">
        <div class="tw-flex tw-flex-col">
          <p class="tw-text-gray-700 tw-text-center tw-mb-3">Unsubscribing...</p>
          <base-spinner class="tw-self-center" />
        </div>
      </base-card>
    </div>
    <div v-if="!isLoading">
      <base-card class="tw-w-96">
        <div v-if="isSuccessful" class="tw-flex tw-flex-col">
          <check-icon class="tw-w-10 tw-h-10 tw-text-green-600 tw-self-center" />
          <p class="tw-text-gray-600 tw-text-center tw-mt-3">You have been successfully unsubscribed from receiving marketing messages from {{ businessName }}</p>
        </div>
        <div v-else class="tw-flex tw-flex-col">
          <alert-icon class="tw-w-10 tw-h-10 tw-text-red-600 tw-self-center" />
          <p class="tw-text-gray-600 tw-text-center tw-mt-3">There was an error unsubscribing.</p>
        </div>
      </base-card>
    </div>
  </div>
</template>

<script>
import { AlertIcon, CheckIcon } from "@/assets/svgs";

export default {
  name: "Unsubscribe",
  components: {
    CheckIcon,
    AlertIcon,
  },
  data() {
    return {
      isLoading: true,
      isSuccessful: false,
      businessName: null,
    };
  },
  created() {
    this.unsubscribe();
  },
  methods: {
    async unsubscribe() {
      try {
        this.isLoading = true;
        const response = await this.$axios.post(`/unsubscribe/${this.$route.params.unsubscribeToken}`);
        this.isSuccessful = response.data.isSuccessful;
        this.businessName = response.data.businessName;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
